import { ReactComponent as MenuIcon } from '../images/Menu.svg'

export default MenuIcon
